import { Directive, ElementRef, inject, output } from "@angular/core";

@Directive({ selector: "[mnOutsideClick]", host: { "(window:click)": "onClick($event)" } })
export class OutsideClickDirective {
  private readonly eR = inject(ElementRef);

  public outsideClick = output<Event>();

  public onClick(event: Event): void {
    if (!this.eR.nativeElement.contains(event.target)) {
      this.outsideClick.emit(event);
    }
  }
}
